import { formatDateWithTime } from "@/shared";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { VALUE_TRANSFORM } from "./TrazabailidadLogFormTab";
import { Typography } from "@mui/material";

export const useColumnsLogConsumption = () => {
    const convertSecondsToTime = (totalSeconds: number) => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return { hours, minutes, seconds };
    };


    const columnsConsumption = useMemo<MRT_ColumnDef<any>[]>(() => [

    {
      accessorKey: 'acctstarttime',
      header: 'Conectado',
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({row})=>formatDateWithTime(row.original?.acctstarttime||"")
    },
    {
      accessorKey: 'acctstoptime',
      header: 'Desconectado',
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({row})=>formatDateWithTime(row.original?.acctstoptime||"")?.replace("Invalid Date","N/A")
    },
    {
      accessorKey: 'acctsessiontime',
      header: 'Tiempo',
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({row})=>{
        const val = convertSecondsToTime(row.original.acctsessiontime)
        return <Typography>{`${val.hours}h ${val.minutes}min ${val.seconds}seg`}</Typography>
      },
    },
    {
      accessorKey: 'acctinputoctets',
      header: 'Descarga',
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({row})=>{
        const gbValue = parseFloat((row.original?.acctinputoctets/VALUE_TRANSFORM)?.toFixed(2))
        const mbValue = parseFloat((row.original?.acctinputoctets/(1024*1024))?.toFixed(2))
        const kbValue = parseFloat((row.original?.acctinputoctets/(1024))?.toFixed(2))
        if(gbValue>0){
          return `${gbValue} GB`
        }else if(mbValue>0){
          return `${mbValue} MB`
        }else{
          return `${kbValue} KB`
        }
      }
    },
    {
      accessorKey: 'acctoutputoctets',
      header: 'Subida',
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({row})=>{
        const gbValue = parseFloat((row.original?.acctinputoctets/VALUE_TRANSFORM)?.toFixed(2))
        const mbValue = parseFloat((row.original?.acctinputoctets/(1024*1024))?.toFixed(2))
        const kbValue = parseFloat((row.original?.acctinputoctets/(1024))?.toFixed(2))
        if(gbValue>0){
          return `${gbValue} GB`
        }else if(mbValue>0){
          return `${mbValue} MB`
        }else{
          return `${kbValue} KB`
        }
      }
    },
    {
      accessorKey: 'framedipaddress',
      header: 'IPV4',
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({row})=>row.original.framedipaddress||"N/A"
    },



  ], []);

  return {
    columnsConsumption
  };
};
